import {
  DetailsCard,
  DetailsCardData,
} from "../../../../components/detailsCard/detailsCard";

interface AmountCardProps {
  amountCardData: DetailsCardData[];
  amountCardHeader: string;
  elementsInOneRow?: number;
  subHeader?: string;
}

const AmountCard = (props: AmountCardProps) => {
  const generateClassName = (level: string) => {
    switch (level) {
      case "Family":
        return "header__sub family";
      case "Individual":
        return "header__sub individual";
      default:
        return "header__sub default";
    }
  };
  return (
    <div className="amount-card-layout">
      <div className="amount-card-layout--header">
        <div className="header__main">{props.amountCardHeader}</div>
        {props.subHeader && (
          <div className={generateClassName(props.subHeader)}>
            {props.subHeader || ""}
          </div>
        )}
      </div>
      <div className="amount-card-layout--content">
        <DetailsCard
          elementsInOneRow={props.elementsInOneRow || 2}
          details={props.amountCardData}
          showBorder={true}
        />
      </div>
    </div>
  );
};

export default AmountCard;
